import * as React from 'react';
import { FormattedMessage  } from 'react-intl';
import { Watch } from 'scrollmonitor-react';

import './footer.scss';

class Footer extends React.Component {

  articleTypeSwitch(articleType) {
    switch(articleType) {
      case "text":
        return <FormattedMessage id="Footer.issueArticlesTitle" defaultMessage="Explore more articles" />
      case "video":
        return <FormattedMessage id="Footer.issueArticlesVideoTitle" defaultMessage="Explore more videos" />
      default:
        return <FormattedMessage id="Footer.issueArticlesTitle" defaultMessage="Explore more articles" />
    } 
  }

  render() {
    
    let tmpPastIssues = [];
    let tmpPastArticles = [];
    let footMessage = "issues";
    let baseUrl = this.props.state.baseUrl ? this.props.state.baseUrl : ".";
    let articleType = this.props.state.loadedArticle.articleType ? this.props.state.loadedArticle.articleType : "text"
    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
 
    // Change classname based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

    if(this.props.state.activeIssueId && this.props.state.activeArticleId) {
      footMessage = "articles";
    }

    if(this.props.state.issues){
      tmpPastIssues = this.props.state.issues.map((item, key) =>
          <div className='col-6 col-md-3 mb-4' key={"menuKey_"+item.issueId+key}>
          {item.issueExtLink &&
            <a className='issue-menu-item' target={'_self'} href={item.issueExtLink}>
              <div className="forced-16-9" style={{backgroundImage: 'url('+baseUrl+item.issueThumbnail+')'}}>
                <img className='issue-menu-thumb img-fluid' src={baseUrl+"/images/16-9.png"} alt={item.issueTitle} />
              </div> 
              <span className='issue-menu-title' >{item.issueTitle}</span>
            </a>
          }
          {!item.issueExtLink &&
            <a className='issue-menu-item' onClick={() => {this.props.changeRoute(item.issueId, "")}} href={'./index.html?issueid='+item.issueId+"&lang="+this.props.state.locale}>
              <div className="forced-16-9" style={{backgroundImage: 'url('+baseUrl+item.issueThumbnail+')'}}>
                <img className='issue-menu-thumb img-fluid' src={baseUrl+"/images/16-9.png"} alt={item.issueTitle} />
              </div> 
              <span className='issue-menu-title' >{item.issueTitle}</span>
            </a>
          }
          </div>
      );
    }

    if(this.props.state.articles){
      tmpPastArticles = this.props.state.articles.map((item, key) => {
            //only render articles of type 'articleType'
            return item.articleType === articleType ? 
            <div className='col-6 col-md-3 mb-4' key={"menuKey_"+item.articleId+key}>
              <a className='issue-menu-item' onClick={() => {this.props.changeRoute(this.props.state.activeIssueId, item.articleId)}} href={'./index.html?issueid='+this.props.state.activeIssueId+'&articleid='+item.articleId+"&lang="+this.props.state.locale}>
                <div className="forced-16-9" style={{backgroundImage: 'url('+baseUrl+item.articleThumbnail+')'}}>
                  <img className='issue-menu-thumb img-fluid' src={baseUrl+"/images/16-9.png"} alt={item.articleTitle} />
                </div> 
                <span className='issue-menu-title' >{item.articleTitle}</span>
              </a>
            </div>
            : 
            ""
          }
      );
    }

    return (
      <footer id="app-footer" className={viewClassName + beenViewed + " footer-" + articleType}>
        <div id="curtain-container">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="h1">{footMessage !== "articles" ? <FormattedMessage id="Footer.pastIssuesTitle" defaultMessage="Explore past issues" /> : this.articleTypeSwitch(articleType)}</h2> 
              </div>
            </div>
            <div className="row">
              {footMessage !== "articles" ? tmpPastIssues : tmpPastArticles}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Watch(Footer);
